export default __webpack_public_path__ + "images/TRACKING_CODE.svg";